/* global bocAmchart4, am4charts, am4plugins_annotation, gaVars, gtagEvent, chartLanguage */

/**
 *
 * @param {Chart} chart The instance of the chart being exported
 * @param {string} format One of the following formats supported by valet: json, csv, xml
 * @param {boolean} useDateRange If 'true', data ranges from the chart will be used to set url parameters
 * @returns {string} Valet URL
 */
bocAmchart4.generateValetLink = function (chart, format, useDateRange) {
    var url = new URL(chart.dataSource.url);
    if (chart.bocSettings.type !== 'pie' && chart.bocSettings.type !== 'map') {
        var isDateAxis = chart.xAxes.values[0] instanceof am4charts.DateAxis;
        // Generate date range parameters only if this is a date axis
        if (useDateRange && isDateAxis) {
            // Date format YYYY-MM-DD
            var startDate = new Date(chart.xAxes.values[0].minZoomed).toISOString().slice(0, 10);
            var endDate = new Date(chart.xAxes.values[0].maxZoomed).toISOString().slice(0, 10);
            url.searchParams.set('start_date', startDate);
            url.searchParams.set('end_date', endDate);
        }
    }
    // Replace original format with user specified format
    url.pathname = url.pathname.replace(/(\/|\/json|\/html|\/xml)$/, "/" + format);

    return url.toString();
};

/**
 * Apply BOC settings to a export menu of the chart
 * @param {Chart} chart The chart options
 * @returns {void}
 */
bocAmchart4.updateExportMenu = function (chart) {
    // Setup variables for google analytics
    var eventCategory = "AmCharts4 - Export";

    // Declare and set a default value
    var slug = '';

    // Make sure Google Analytics is set up
    if (typeof gaVars === 'object') {
        slug = gaVars.baseUrl;
        if (gaVars.baseUrl !== gaVars.pageUrl) {
            slug = gaVars.pageUrl.replace(gaVars.baseUrl, '');
        }
    }

    // Set default title
    var title = "AmCharts4";
    // Get title from the chart but make sure 'charttitle' was specified as a shortcode parameter
    if (chart.bocSettings.args.hasOwnProperty('charttitle') && 'text' in chart.title.children.getIndex(0)) {
        // Grabing title from chart instead fo bocSettings in case the title was processed
        title = chart.title.children.getIndex(0).text;
    }
    // Setting variable for notesContainer if autohidenotes and note parameters are set and a variable to check if the showNotes function is called or not

    var notes;
    var callShowNotes;
    var initialHeight;
    if (chart.notes && chart.bocSettings.args.hasOwnProperty('autohidenotes') && chart.bocSettings.args.autohidenotes === "true") {
        notes = chart.notes.htmlContainer;
        callShowNotes = false;
    }

    //Function to detect the state of notes and changing the noteContainer max-height
    // Language detection is also in the function to determine the textContent of the button
    var showNotes = function () {
        var showNotesButton = document.getElementById(chart.bocSettings.id + "-hide-notes");
        callShowNotes = true;
        initialHeight = notes.style.height;
        if (notes.classList.contains('hidden-notes')) {
            notes.style.transition = "";
            notes.style.maxHeight = initialHeight;
            notes.classList.remove('hidden-notes');

            if (chartLanguage === "fr") {
                showNotesButton.textContent = "Cacher les notes";
            } else {
                showNotesButton.textContent = "Hide notes";
            }
        } else {
            notes.style.transition = "max-height 1.2s cubic-bezier(0.2, 0, 0.2, 1)";
            notes.style.maxHeight = "0";
            notes.classList.add('hidden-notes');

            if (chartLanguage === "fr") {
                showNotesButton.textContent = "Afficher les notes";
            } else {
                showNotesButton.textContent = "Show notes";
            }
        }
    };

    // NOTE: Labels will be automatically translated if strings are included in amcharts4Translations
    var saveMenu = {
        "label": "Save image ...",
        "menu": [
            {
                "type": "custom",
                "label": "PNG",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - PNG";
                        gtagEvent(eventCategory, eventAction, slug);

                        chart.exporting.export("png");

                    }
                }
            },
            {
                "type": "custom",
                "label": "JPG",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - JPG";
                        gtagEvent(eventCategory, eventAction, slug);


                        chart.exporting.export("jpg");

                    }
                }
            },
            {
                "type": "custom",
                "label": "PDF",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - PDF";
                        gtagEvent(eventCategory, eventAction, slug);

                        chart.exporting.export("pdf");

                    }
                }
            }
        ]
    };

    var downloadAllMenu = {
        "label": "Download all ...",
        "menu": [
            {
                "type": "custom",
                "label": "CSV",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - CSV";
                        gtagEvent(eventCategory, eventAction, slug);

                        window.location =
                            bocAmchart4.generateValetLink(chart, "csv", false);
                    }
                }
            },
            {
                "type": "custom",
                "label": "JSON",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - JSON";
                        gtagEvent(eventCategory, eventAction, slug);

                        window.location =
                            bocAmchart4.generateValetLink(chart, "json", false);
                    }
                }
            },
            {
                "type": "custom",
                "label": "XML",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - XML";
                        gtagEvent(eventCategory, eventAction, slug);

                        window.location =
                            bocAmchart4.generateValetLink(chart, "xml", false);
                    }
                }
            }
        ]
    };

    var downloadDateRangeMenu = {
        "label": "Download date range ...",
        "menu": [
            {
                "type": "custom",
                "label": "CSV",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - CSV";
                        gtagEvent(eventCategory, eventAction, slug);

                        window.location =
                            bocAmchart4.generateValetLink(chart, "csv", true);
                    }
                }
            },
            {
                "type": "custom",
                "label": "JSON",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - JSON";
                        gtagEvent(eventCategory, eventAction, slug);

                        window.location =
                            bocAmchart4.generateValetLink(chart, "json", true);
                    }
                }
            },
            {
                "type": "custom",
                "label": "XML",
                "options": {
                    "callback": function () {
                        var eventAction = bocAmchart4.getChartTitle(chart) + " - XML";
                        gtagEvent(eventCategory, eventAction, slug);

                        window.location =
                            bocAmchart4.generateValetLink(chart, "xml", true);
                    }
                }
            }
        ]
    };

    var printMenu = {
        "label": "Print",
        "type": "custom",
        "options": {
            "callback": function () {
                var eventAction = bocAmchart4.getChartTitle(chart) + " - Print";
                gtagEvent(eventCategory, eventAction, slug);

                chart.exporting.export('print');
            }
        }
    };

    var topMenu = [];

    if (chart.bocSettings.downloadOnly === true) {
        //only show the download All
        topMenu.push(downloadAllMenu);
    } else {
        topMenu.push(saveMenu);

        // If data is NOT retrieved from uploads (it doesn't use a datasource property),
        // then add the download all menu (CSV, JSON, XML).
        if (!chart.bocSettings.args.hasOwnProperty('datasource')
            && !chart.bocSettings.args.hasOwnProperty('skipdataloading')) {
            topMenu.push(downloadAllMenu);
            // For non-pie and non-map charts, add the download date range to exporter (CSV, JSON, XML).
            if (chart.bocSettings.type !== 'pie' && chart.bocSettings.type !== 'map') {
                var isDateAxis = chart.xAxes.values[0] instanceof am4charts.DateAxis;
                if (chart.bocSettings.lookup && isDateAxis) {
                    // Add option to download only visible data.
                    topMenu.push(downloadDateRangeMenu);
                }
            }
        }
        topMenu.push(printMenu);
    }

    var svgExportIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 11 14">' +
        '<path d="M3,0 L8,0 L8,5 L11,5 L5.5,10 L0,5 L3,5 L03,0" fill="#888"/>' +
        '<rect x="0" y="12" fill="#888" width="11" height="2"/>' +
        '</svg>';
    chart.exporting.menu.items = [
        {
            "svg": svgExportIcon,
            "menu": topMenu
        }
    ];
    chart.exporting.events.on("exportstarted", function () {
        //Converts note from html to text to allow exporting

        if (chart.notes) {
            //Ensuring that the state is currently in hidden then trigger showNotes, otherwise it is not necessary as printing will works fine
            if (chart.notes.htmlContainer.classList.contains('hidden-notes')) {
                showNotes();
            }

            for (let ch = 0; ch < chart.notes.children.values.length; ch++) {
                var note = chart.notes.children.getIndex(0);
                var newNote = note.clone();
                var html = note.htmlContent;
                var text = note.textContent;
                newNote.html = undefined;
                note.dispose();
                newNote.parent = chart.notes;
                newNote.text = text;
                newNote.textContent = text;
                newNote.htmlContent = html;
            }
        }
    });

    chart.exporting.events.on("exportfinished", function () {
        //Converts note to html to allow displaying of shortcode, invalidates to rescale accordingly
        if (chart.notes) {
            if (callShowNotes) {
                showNotes();
                callShowNotes = false;
            }

            for (let ch = 0; ch < chart.notes.children.values.length; ch++) {
                var note = chart.notes.children.getIndex(0);
                note.html = note.htmlContent;
            }
            chart.notes.invalidate();
        }
    });
    // Set file name prefix based on series name
    chart.exporting.filePrefix = chart.language.translate("BoC_Chart");
    if (typeof chart.bocSettings.series !== "undefined") {
        // Get only the series name after last forward slash
        chart.exporting.filePrefix = chart.bocSettings.series.split('/').pop();
    }

    /* eslint-disable camelcase */
    var annotation = chart.plugins.push(new am4plugins_annotation.Annotation());
    let exportMenuLength = chart.exporting.menu.items[0].menu.length;
    for (let index = 0; index < exportMenuLength; index++) {
        if (chart.exporting.menu.items[0].menu[index].label === 'Annotate ...') {
            chart.exporting.menu.items[0].menu[index].options.callback = function () {
                annotation.active = !annotation.active;
                if (annotation.active) {
                    var eventAction = bocAmchart4.getChartTitle(chart) + " - Annotate";
                    gtagEvent(eventCategory, eventAction, slug);
                }
            };
        }
    }
    /* eslint-enable camelcase */

    // Position of export menu icon
    chart.exporting.menu.align = "right";
    chart.exporting.menu.verticalAlign = "top";
};
